import React, { Children } from 'react';
import { motion } from 'framer-motion';
const deliverables = [{
  emoji: '📋',
  title: 'Menú de 7 días completo',
  description: 'Desayuno, comida y cena organizados día por día.'
}, {
  emoji: '🥗',
  title: 'Recetas simples y rápidas',
  description: 'Preparaciones de 15-20 minutos con ingredientes accesibles.'
}, {
  emoji: '🛒',
  title: 'Lista de compras semanal',
  description: 'Todo lo que necesitas comprar, listo para llevar al supermercado.'
}, {
  emoji: '💧',
  title: 'Guía de hidratación',
  description: 'Cuánto, cuándo y qué tomar para reducir la retención.'
}, {
  emoji: '🌿',
  title: 'Lista de alimentos anti-inflamatorios',
  description: 'Qué incluir y qué evitar durante los 7 días.'
}, {
  emoji: '⏰',
  title: 'Rutina matutina de 10 minutos',
  description: 'Ejercicios suaves para activar tu digestión cada mañana.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="bg-wellness-white py-20 px-6" id="benefits" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-wellness-dark mb-4" data-id="element-18">
            ¿Qué incluye la guía?
          </h2>
          <p className="text-lg text-wellness-dark/70 max-w-2xl mx-auto" data-id="element-19">
            Todo organizado en un PDF claro y fácil de seguir.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-20">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-6 shadow-sm border border-wellness-light-sage/50" data-id="element-21">
              <div className="text-3xl mb-3" data-id="element-22">{item.emoji}</div>
              <h3 className="font-bold text-wellness-dark mb-2" data-id="element-23">
                {item.title}
              </h3>
              <p className="text-sm text-wellness-dark/70" data-id="element-24">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}